<template>
    <div>
        <div class="row warehouses-row">
            <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" >
                <template>
                    <b-form-checkbox
                            v-for="option in roles.slice(0, Math.ceil(roles.length/2))"
                            v-model="option.value"
                            :disabled="type === option.name"
                    >
                        {{ namingRoles($t(`roles.${option.name}`)) }}
                    </b-form-checkbox>
                </template>
            </div>
            <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" >
                <template>
                    <b-form-checkbox
                            v-for="option in roles.slice(Math.ceil(roles.length/2), roles.length)"
                            v-model="option.value"
                            :disabled="type === option.name"
                    >
                        {{ namingRoles($t(`roles.${option.name}`)) }}
                    </b-form-checkbox>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'roles',
  data () {
    return {
      showAlert: 0
    }
  },
  props: [
    'roles',
    'type',
    'user'
  ],
  methods: {
    /* changeRole (role) {
      console.log('intra aicicccccc')
      let roleClone = this.roles.map(a => Object.assign({}, a))
      roleClone = roleClone.filter(function (role) {
        if (role.value === true) {
          return true
        }
      })
      if (roleClone.length) {
        if (this.showAlert === 0) {
           if (confirm('Vrei sa schimbi rolul de ' + roleClone.name)) {
             //
           }
        }
      }
      this.showAlert += 1

    } */
  },
  mounted () {
    this.$store.dispatch('hideLoading')
  }
}

</script>
